import { Head } from '@unhead/react';
import { useTranslation } from '@wojtekmaj/react-t';

import { MODE, PROD } from '../env';

const shortMode = MODE === 'development' ? 'dev' : MODE;

const title = PROD ? 'Rewardo Business' : `Rewardo Business ${shortMode.toUpperCase()}`;

type TitleProps = {
  children?: string;
};

export default function Title({ children }: TitleProps) {
  const translatedChildren = useTranslation(children);

  return (
    <Head>
      <title>{translatedChildren ? `${translatedChildren} • ${title}` : title}</title>
    </Head>
  );
}
